import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/_work/back-office/back-office/apps/back-office/layouts/default.vue").then(m => m.default || m)),
  settings: defineAsyncComponent(() => import("/home/runner/_work/back-office/back-office/apps/back-office/layouts/settings.vue").then(m => m.default || m))
}